// The five project photos and what each one actually shows (used for alt text).
export const PHOTOS = {
    openKitchen: { src: '/assets/images/1.webp', alt: 'Open-concept kitchen and dining room remodel' },
    navyKitchen: { src: '/assets/images/2.webp', alt: 'Kitchen remodel with navy island and marble countertop' },
    whiteKitchen: { src: '/assets/images/3.webp', alt: 'White kitchen remodel with waterfall island and pendant lights' },
    showerBath: { src: '/assets/images/4.webp', alt: 'Bathroom remodel with glass walk-in shower' },
    tubBath: { src: '/assets/images/5.webp', alt: 'Primary bathroom remodel with freestanding tub' },
};

export const altFor = (src) => Object.values(PHOTOS).find((p) => p.src === src)?.alt || '';

// Responsive sources: every photo has a 1600px original and an 800px "-800" copy.
export const srcSetFor = (src) => `${src.replace(/\.webp$/, '-800.webp')} 800w, ${src} 1600w`;

// <link rel="preload"> for a page's hero photo, rendered into <head> via Helmet.
export const heroPreload = (src) => ({ rel: 'preload', as: 'image', href: src, imagesrcset: srcSetFor(src), imagesizes: '100vw', fetchpriority: 'high' });
